import 'react-toastify/dist/ReactToastify.css';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';
import { LoginScreen, PostCodes } from './pages';
import { DashboardLayout } from './components/layouts';
import ProtectedRoute from './components/ProtectedRoute';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './context/authContext';
import { PostCodeProvider } from './context/postCodeContext';

const App = () => {
    return (
        <>
            <ToastContainer />
            <AuthProvider>
                <PostCodeProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<LoginScreen />} index />
                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <DashboardLayout />
                                    </ProtectedRoute>
                                }>
                                <Route
                                    index
                                    element={
                                        <ProtectedRoute>
                                            <PostCodes />
                                        </ProtectedRoute>
                                    }
                                />
                            </Route>
                        </Routes>
                    </BrowserRouter>
                </PostCodeProvider>
            </AuthProvider>
        </>
    );
};
export default App;
